import type { HTMLAttributes } from 'vue'
import type { Component } from 'vue'

export enum Dialogs {
  // Account (~14)
  ChangeName = 'ChangeName',
  ChangeEmail = 'ChangeEmail',
  ChangePassword = 'ChangePassword',
  ChangeUsername = 'ChangeUsername',
  ChangeTitle = 'ChangeTitle',
  ChangeBio = 'ChangeBio',
  ChangeCompanyName = 'ChangeCompanyName',
  DeactivateAccount = 'DeactivateAccount',
  DeactivateAccountPrompt = 'DeactivateAccountPrompt',
  DeleteAccount = 'DeleteAccount',
  ConfirmDeactivateAccount = 'ConfirmDeactivateAccount',
  ConfirmDeleteAccount = 'ConfirmDeleteAccount',
  UploadProfilePicture = 'UploadProfilePicture',
  ConfirmProfilePicture = 'ConfirmProfilePicture',

  // File (~25)
  FileAccess = 'FileAccess',
  FileSettings = 'FileSettings',
  FilePrivacySettings = 'FilePrivacySettings',
  FileOwners = 'FileOwners',
  FileAuthors = 'FileAuthors',
  Share = 'Share',
  Download = 'Download',
  ProcessingDownload = 'ProcessingDownload',
  AddFolder = 'AddFolder',
  RenameFolder = 'RenameFolder',
  MoveItems = 'MoveItems',
  ConfirmMove = 'ConfirmMove',
  DeleteFolders = 'DeleteFolders',
  CannotDeleteFolder = 'CannotDeleteFolder',
  ArchiveFiles = 'ArchiveFiles',
  ConfirmArchiveFiles = 'ConfirmArchiveFiles',
  MakeFilesPrivate = 'MakeFilesPrivate',
  MakeFilesPublic = 'MakeFilesPublic',
  UpdateFilePrivacy = 'UpdateFilePrivacy',
  DefaultFilePrivacy = 'DefaultFilePrivacy',
  RemoveFileAccess = 'RemoveFileAccess',
  RemoveFileOwner = 'RemoveFileOwner',
  RemoveFileAuthor = 'RemoveFileAuthor',
  ManageAccessTip = 'ManageAccessTip',
  SelectFolder = 'SelectFolder',

  // Copyright (~10)
  CopyrightOwners = 'CopyrightOwners',
  NewCopyrightOwner = 'NewCopyrightOwner',
  EditCopyrightOwner = 'EditCopyrightOwner',
  DeleteCopyrightOwner = 'DeleteCopyrightOwner',
  SelectCopyright = 'SelectCopyright',
  AddNewCopyright = 'AddNewCopyright',
  AllOwners = 'AllOwners',
  AllAuthors = 'AllAuthors',
  OwnersAuthorsTip = 'OwnersAuthorsTip',
  CopyrightPageTip = 'CopyrightPageTip',

  // Billing (~14)
  Pay = 'Pay',
  PayCredits = 'PayCredits',
  CancelSubscription = 'CancelSubscription',
  ConfirmCancelSubscription = 'ConfirmCancelSubscription',
  Resubscribe = 'Resubscribe',
  ResubscribeIAP = 'ResubscribeIAP',
  IAP = 'IAP',
  CantPay = 'CantPay',
  ConfirmPaymentMethod = 'ConfirmPaymentMethod',
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  SelectPlanBilling = 'SelectPlanBilling',
  PlanDetails = 'PlanDetails',
  UpcomingBillingDetails = 'UpcomingBillingDetails',
  BuyReportCredits = 'BuyReportCredits',

  // Upload (~8)
  UploadDetails = 'UploadDetails',
  ConfirmUpload = 'ConfirmUpload',
  ConfirmUploadDetails = 'ConfirmUploadDetails',
  CancelUpload = 'CancelUpload',
  PreUploadPrivacy = 'PreUploadPrivacy',
  OriginalCreator = 'OriginalCreator',
  FirstProUpload = 'FirstProUpload',
  UploadTip = 'UploadTip',

  // Infringement (~3)
  InfringementReport = 'InfringementReport',
  InfringementMatches = 'InfringementMatches',
  CreateReport = 'CreateReport',
  MatchPair = 'MatchPair',
  ShareReport = 'ShareReport',

  // Upgrade (~3)
  UpgradeToPro = 'UpgradeToPro',
  UpgradeBundleLimit = 'UpgradeBundleLimit',
  Upsell = 'Upsell',

  // Search (~2)
  SearchFilter = 'SearchFilter',
  SearchSort = 'SearchSort',

  // Explorer Mobile (~5)
  ThreeDotsMenu = 'ThreeDotsMenu',
  FileActions = 'FileActions',
  FolderActions = 'FolderActions',
  CopyrightInfo = 'CopyrightInfo',
  FolderInfo = 'FolderInfo',
  ArchiveMenu = 'ArchiveMenu',
  NotificationMenu = 'NotificationMenu',

  // Misc (~10)
  Error = 'Error',
  Success = 'Success',
  UpdatedTerms = 'UpdatedTerms',
  WelcomeBack = 'WelcomeBack',
  WelcomeToDacrPro = 'WelcomeToDacrPro',
  FromInvite = 'FromInvite',
  AddOrigins = 'AddOrigins',
  Registrations = 'Registrations',
  ReportFeedback = 'ReportFeedback',
  TransactionHistory = 'TransactionHistory',
}

export interface DialogEvents {
  close?: (data?: unknown) => void
  success?: (data?: unknown) => void
}

export interface DialogOptions {
  name: Dialogs
  props?: Record<string, unknown>
  stack?: boolean
  events?: DialogEvents
}

export type DialogPresentation = 'adaptive' | 'modal'
export type DialogSlideupHeight = 'content' | 'viewport'

export interface DialogRegistryOptions {
  presentation?: DialogPresentation
  modal?: {
    class?: HTMLAttributes['class']
  }
  slideup?: {
    class?: HTMLAttributes['class']
    height?: DialogSlideupHeight
  }
}

export interface DialogRegistryEntry extends DialogRegistryOptions {
  component: Component
}

export interface DialogRuntimeOptions {
  hideCloseButton?: boolean
  preventOutsideClick?: boolean
}
